import Vue from 'vue'
import App from './App.vue'

import { AUTH_STORAGE_TOKEN } from './constants'

import 'normalize.css'

import fullscreen from 'vue-fullscreen'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faBeer, faExpand } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faBeer, faExpand)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(fullscreen)

Vue.config.productionTip = false

const authToken = localStorage.getItem(AUTH_STORAGE_TOKEN)

if (!authToken) {
  const token = window.prompt('Auth or leave blank')
  localStorage.setItem(AUTH_STORAGE_TOKEN, token)
}

new Vue({
  render: h => h(App)
}).$mount('#app')
